module.exports = __webpack_public_path__ + "html/week3_df0f716fff2548446c827d7199219752.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week3.html
// module id = 6cC1
// module chunks = 118